<m-popup class="m-tooltip"
         :class="{ 'm--is-disabled': disabled,
                   'm--is-mode-definition': isModeDefinition }"
         :class-name="className"
         :close-on-backdrop="true"
         :focus-management="isMqMaxS"
         :open.sync="propOpen"
         :padding="false"
         :background="false"
         :placement="placement"
         :disabled="disabled"
         @open="onOpen"
         @close="onClose">
    <m-icon-button :id="id"
                   class="m-tooltip__icon"
                   v-if="isModeIcon"
                   :aria-controls="ariaControls"
                   :aria-expanded="propOpen"
                   slot="trigger"
                   :icon-name="iconName"
                   :title="title"
                   button-size="22px"
                   :disabled="disabled">
    </m-icon-button>
    <m-link :id="id"
            class="m-tooltip__link"
            v-else
            @click="onClick"
            aria-haspopup="true"
            :aria-controls="ariaControls"
            :aria-expanded="propOpen"
            slot="trigger"
            mode="button"
            :underline="isModeLink"
            :disabled="disabled">
        <slot name="link"></slot>
    </m-link>
    <div :id="ariaControls"
         class="m-tooltip__body-container"
         :class="{ 'm--is-mode-icon': isModeIcon,
                   'm--is-size-large': isSizeLarge,
                   'm--has-close-button': hasCloseButton }"
         :aria-labelledby="id">
        <m-icon-button class="m-tooltip__close-button"
                       v-if="hasCloseButton"
                       @click="close"
                       icon-name="m-svg__close-clear"
                       icon-size="14px"
                       :svg-tile="CloseTitle">
        </m-icon-button>
        <div class="m-tooltip__body">
            <slot></slot>
        </div>
    </div>
</m-popup>
